import React from 'react';
import styled from 'styled-components';
import { Field } from 'react-final-form';
import BlockableRow from '../BlockableRow';
import { parseToPositiveNumber } from '../../../../../../../common/utils/fieldValidators';

const IS_ACTIVE_KEY = 'trigger.rules.MobileAppRatingDeclined.isActive';

const StyledElement = styled.div`
  input {
    width: 65px;
  }
`;


const TargetByPreviousDecline = () => (
  <BlockableRow
    title="Don’t invite a visitor who declined an App Rating prompt in the past"
    isActiveFieldName={IS_ACTIVE_KEY}
    labelWeight={3}
    inputWeight={4}>
    <StyledElement>
      <Field parse={(value) => parseToPositiveNumber(value)} name="trigger.rules.MobileAppRatingDeclined.params.days" render={({ input }) => (
        <React.Fragment>
          <input  {...input} type="number" /><label>&nbsp;&nbsp;Days</label>
        </React.Fragment>
      )} />
    </StyledElement>
  </BlockableRow>
);

export default TargetByPreviousDecline;
